export let productCenterHiLViewEN = {
  multiSensorHiLModule1: {
    h1: "Multi-sensor HiL simulation in the loop",
    h2: "Real-time multi-path efficient multi-concurrent",
  },
  multiSensorHiLModule2: {
    h1: "Medusa Physics-Based Multi-Sensor Simulation & Injection Solution",
    multiSensorHiLModule2ProcessLeft: {
      multiSensorHiLModule2Arr: [
        "Based on sensor assembly",
        "Sensing layer injection",
        "Raw sensor data injection",
        "Perception layer injection",
        "Target list injection and restbus simulation",
        "Fusion layer injection",
      ],
    },
    multiSensorHiLModule2ProcessRight: {
      multiSensorHiLModule2Arr: [
        "Sensing",
        "Sensor front-end",
        "Perception",
        "Signal processing",
        "Fusion",
        "Data fusion Positioning",
        "Application",
        "Prediction/Planning/Decision-making  Control",
      ],
    },
    // testObject: "ADAS/AD test object",
    testObject: "ADAS/AD test object",
  },
  multiSensorHiLModule3:
    "Real-Time Multi-Source, with High Efficiency and Concurrency",
};
export let productCenterHiLViewCN = {
  multiSensorHiLModule1: {
    h1: "多传感器HiL在环仿真",
    h2: "实时多路径 高效多并发",
  },
  multiSensorHiLModule2: {
    h1: "美杜莎物理级多传感器仿真注入方案",
    multiSensorHiLModule2ProcessLeft: {
      multiSensorHiLModule2Arr: [
        "基于传感器总成",
        "传感层注入",
        "传感器原始数据注入",
        "感知层注入",
        "目标列表注入及残余总线仿真",
        "融合层注入",
      ],
    },
    multiSensorHiLModule2ProcessRight: {
      multiSensorHiLModule2Arr: [
        "传感",
        "传感器前端",
        "感知",
        "信号处理",
        "融合",
        "数据融合  定位",
        "应用",
        " 预测  /  规划  /  决策   控制",
      ],
    },
    // testObject: "ADAS/AD被测对象",
    testObject: "A\nD\nA\nS\n/\nA\nD\n被\n测\n对\n象",
  },
  multiSensorHiLModule3: "实时多路径，高效多并发",
};
